import React, { useEffect, useState } from 'react'

export interface OriginalEvents {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  onBlur: (e: React.FocusEvent<HTMLInputElement>) => void
  onFocus: (e: React.FocusEvent<HTMLInputElement>) => void
}

export const useMaskedValue = (value: string, mapMask: (value: string) => string, events: OriginalEvents) => {
  const [masked, setMasked] = useState(value)
  const [isEditting, setEditting] = useState(false)

  useEffect(() => {
    setMasked(mapMask(value))
  }, [value])

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const maskedValue = mapMask(value)

    setMasked(maskedValue)

    events.onChange(e)
  }

  const onBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    setEditting(false)

    events.onBlur(e)
  }

  const onFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    setEditting(true)

    events.onFocus(e)
  }

  return [isEditting ? value : masked, { onChange, onBlur, onFocus }, isEditting] as const
}

export default useMaskedValue
